module.exports = __webpack_public_path__ + "fonts/SpiritsNeutral-Black.a9391497.woff2";